(function() {
  'use strict';

  angular
    .module('observatoireApp')
    .controller('AutorisationsMinieresCtrl', AutorisationsMinieresCtrl);

  /** @ngInject */
  AutorisationsMinieresCtrl.$inject = ['$scope', '$http', 'AutorisationsMinieresService', 'MetaService'];
  function AutorisationsMinieresCtrl($scope, $http, AutorisationsMinieresService, MetaService) {
    // Définir les métadonnées de la page
    MetaService.setTitle('Autorisations minières');
    
    // Initialiser les variables du scope
    $scope.autorisationsMinieres = [];
    $scope.autorisationsMinieresFilterees = [];
    $scope.isLoading = true;
    $scope.filterData = {};
    $scope.filtres = {
      query: '',
      typeAutorisation: '',
      region: '',
      substance: '',
      statut: '',
      anneeMin: null,
      anneeMax: null
    };
    
    // Utilitaire Math pour les templates
    $scope.Math = window.Math;
    
    // Mode d'affichage (table ou map)
    $scope.viewMode = 'table';
    
    // Observer le changement de mode d'affichage
    $scope.$watch('viewMode', function(newMode) {
      if (newMode === 'map' && $scope.autorisationsMinieresFilterees.length > 0) {
        // Initialiser la carte à la prochaine exécution (asynchrone)
        setTimeout(function() {
          initMap();
        }, 100);
      }
    });
    
    // Pagination
    $scope.pagination = {
      currentPage: 1,
      itemsPerPage: 10,
      totalItems: 0,
      pageSizeOptions: [5, 10, 25, 50, 100]
    };
    
    // Initialiser les données
    initialize();
    
    function initialize() {
      // Charger les données de filtrage
      loadFilterData();
      
      // Charger les autorisations minières
      loadAutorisationsMinieres();
    }
    
    function loadFilterData() {
      AutorisationsMinieresService.getFilterData()
        .then(function(data) {
          $scope.filterData = data;
        })
        .catch(function(error) {
          console.error('Erreur lors du chargement des données de filtrage', error);
        });
    }
    
    function loadAutorisationsMinieres() {
      $scope.isLoading = true;
      
      AutorisationsMinieresService.getAllAutorisationsMinieres()
        .then(function(data) {
          // Convertir les dates au format tableau en objets Date
          $scope.autorisationsMinieres = data.map(function(autorisation) {
            if (autorisation.dateAttribution && Array.isArray(autorisation.dateAttribution)) {
              autorisation.dateAttribution = convertArrayToDate(autorisation.dateAttribution);
            }
            if (autorisation.dateExpiration && Array.isArray(autorisation.dateExpiration)) {
              autorisation.dateExpiration = convertArrayToDate(autorisation.dateExpiration);
            }
            if (autorisation.dateDerniereModification && Array.isArray(autorisation.dateDerniereModification)) {
              autorisation.dateDerniereModification = convertArrayToDate(autorisation.dateDerniereModification);
            }
            return autorisation;
          });
          applyFilters();
          $scope.isLoading = false;
        })
        .catch(function(error) {
          console.error('Erreur lors du chargement des autorisations minières', error);
          $scope.isLoading = false;
        });
    }
    
    // Fonction utilitaire pour convertir un tableau de date [année, mois, jour, ...] en objet Date
    function convertArrayToDate(dateArray) {
      if (!Array.isArray(dateArray) || dateArray.length < 3) {
        return null;
      }
      // Note: les mois dans JavaScript commencent à 0, donc on soustrait 1 au mois
      var year = dateArray[0];
      var month = dateArray[1] - 1; // Ajuster le mois pour JavaScript (0-11)
      var day = dateArray[2];
      var hours = dateArray.length > 3 ? dateArray[3] : 0;
      var minutes = dateArray.length > 4 ? dateArray[4] : 0;
      
      return new Date(year, month, day, hours, minutes);
    }
    
    // Fonctions de filtrage
    $scope.applyFilters = function() {
      applyFilters();
      
      // Réinitialiser la pagination à la première page après filtrage
      $scope.pagination.currentPage = 1;
      
      // Si en mode carte, initialiser la carte après filtrage
      if ($scope.viewMode === 'map') {
        setTimeout(function() {
          initMap();
        }, 100);
      }
    };
    
    function applyFilters() {
      // Filtrer les autorisations minières selon les critères
      $scope.autorisationsMinieresFilterees = $scope.autorisationsMinieres.filter(function(autorisation) {
        // Filtrage par terme de recherche
        if ($scope.filtres.query && $scope.filtres.query.trim() !== '') {
          var searchTerm = $scope.filtres.query.toLowerCase();
          var matchesQuery = false;
          
          // Vérifier si le terme se trouve dans les champs principaux
          if (autorisation.numeroAutorisation && autorisation.numeroAutorisation.toLowerCase().includes(searchTerm) ||
              autorisation.societe && autorisation.societe.toLowerCase().includes(searchTerm) ||
              autorisation.substance && autorisation.substance.toLowerCase().includes(searchTerm) ||
              autorisation.region && autorisation.region.toLowerCase().includes(searchTerm)) {
            matchesQuery = true;
          }
          
          if (!matchesQuery) {
            return false;
          }
        }
        
        // Filtrage par type d'autorisation
        if ($scope.filtres.typeAutorisation && autorisation.typeAutorisation !== $scope.filtres.typeAutorisation) {
          return false;
        }
        
        // Filtrage par région
        if ($scope.filtres.region && autorisation.region !== $scope.filtres.region) {
          return false;
        }
        
        // Filtrage par substance
        if ($scope.filtres.substance && autorisation.substance !== $scope.filtres.substance) {
          return false;
        }
        
        // Filtrage par statut
        if ($scope.filtres.statut && autorisation.statut !== $scope.filtres.statut) {
          return false;
        }
        
        // Filtrage par année minimale
        if ($scope.filtres.anneeMin && autorisation.dateAttribution) {
          var anneeAttribution = new Date(autorisation.dateAttribution).getFullYear();
          if (anneeAttribution < $scope.filtres.anneeMin) {
            return false;
          }
        }
        
        // Filtrage par année maximale
        if ($scope.filtres.anneeMax && autorisation.dateAttribution) {
          var anneeAttribution = new Date(autorisation.dateAttribution).getFullYear();
          if (anneeAttribution > $scope.filtres.anneeMax) {
            return false;
          }
        }
        
        return true;
      });
      
      // Mettre à jour le nombre total d'items pour la pagination
      $scope.pagination.totalItems = $scope.autorisationsMinieresFilterees.length;
      
      // Si aucun résultat, afficher un message
      if ($scope.autorisationsMinieresFilterees.length === 0) {
        console.log('Aucune autorisation minière ne correspond aux critères de recherche');
      }
    }
    
    // Pagination
    $scope.updatePagination = function() {
      $scope.pagination.totalItems = $scope.autorisationsMinieresFilterees.length;
    };
    
    /**
     * Génère un tableau des numéros de pages à afficher
     * @returns {Array} - Numéros de pages
     */
    $scope.getPages = function() {
      const totalPages = Math.ceil($scope.autorisationsMinieresFilterees.length / $scope.pagination.itemsPerPage);
      const currentPage = $scope.pagination.currentPage;
      const maxPagesToShow = 5; // Nombre maximum de pages à montrer
      
      // Si peu de pages, on les montre toutes
      if (totalPages <= maxPagesToShow) {
        return Array.from({length: totalPages}, (_, i) => i + 1);
      }
      
      // Sinon on génère un tableau avec des ellipses
      let pages = [];
      
      // Toujours inclure la première page
      pages.push(1);
      
      // Calculer la plage de pages autour de la page courante
      const leftOffset = Math.floor((maxPagesToShow - 2) / 2);
      const rightOffset = maxPagesToShow - 2 - leftOffset;
      
      let rangeStart = currentPage - leftOffset;
      let rangeEnd = currentPage + rightOffset;
      
      // Ajuster si la plage dépasse les limites
      if (rangeStart <= 1) {
        rangeStart = 2;
        rangeEnd = Math.min(totalPages - 1, maxPagesToShow - 1);
      } else if (rangeEnd >= totalPages) {
        rangeEnd = totalPages - 1;
        rangeStart = Math.max(2, totalPages - (maxPagesToShow - 2));
      }
      
      // Ajouter ellipse si nécessaire avant la plage
      if (rangeStart > 2) {
        pages.push('...');
      }
      
      // Ajouter les pages dans la plage
      for (let i = rangeStart; i <= rangeEnd; i++) {
        pages.push(i);
      }
      
      // Ajouter ellipse si nécessaire après la plage
      if (rangeEnd < totalPages - 1) {
        pages.push('...');
      }
      
      // Toujours inclure la dernière page si elle existe
      if (totalPages > 1) {
        pages.push(totalPages);
      }
      
      return pages;
    };
    
    /**
     * Changer le nombre d'éléments par page
     * @param {number} nombreElements - Nombre d'éléments à afficher par page
     */
    $scope.changerElementsParPage = function(nombreElements) {
      $scope.pagination.itemsPerPage = nombreElements;
      $scope.pagination.currentPage = 1; // Revenir à la première page
      $scope.pageChanged();
    };
    
    $scope.pageChanged = function() {
      // Calculer l'index de début et de fin pour l'affichage paginé
      var startIndex = ($scope.pagination.currentPage - 1) * $scope.pagination.itemsPerPage;
      var endIndex = startIndex + $scope.pagination.itemsPerPage;
      
      // Limiter la fin à la taille du tableau
      endIndex = Math.min(endIndex, $scope.autorisationsMinieresFilterees.length);
    };
    
    $scope.resetFilters = function() {
      $scope.filtres = {
        query: '',
        typeAutorisation: '',
        region: '',
        substance: '',
        statut: '',
        anneeMin: null,
        anneeMax: null
      };
      
      applyFilters();
      
      // Réinitialiser la pagination
      $scope.pagination.currentPage = 1;
      
      // Si en mode carte, réinitialiser la carte
      if ($scope.viewMode === 'map') {
        setTimeout(function() {
          initMap();
        }, 100);
      }
    };
    
    // Initialisation de la carte
    function initMap() {
      // Vérifier si la carte existe déjà
      if (window.autorisationsMap) {
        window.autorisationsMap.remove();
      }
      
      // Vérifier que Leaflet est disponible
      if (typeof L === 'undefined') {
        console.error("Leaflet n'est pas chargé");
        document.getElementById('map-fallback-message').style.display = 'block';
        return;
      }
      
      // Vérifier que le conteneur de carte existe
      var mapContainer = document.getElementById('autorisations-map');
      if (!mapContainer) {
        console.error("Le conteneur de carte n'existe pas");
        return;
      }
      
      try {
        // Initialiser la carte centrée sur le Tchad
        window.autorisationsMap = L.map('autorisations-map').setView([15.454166, 18.732207], 5);
        
        // Ajouter la couche de tuiles OpenStreetMap
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(window.autorisationsMap);
        
        // Créer un groupe de marqueurs pour les autorisations
        var markers = L.markerClusterGroup();
        
        // Ajouter des marqueurs pour chaque autorisation avec coordonnées
        $scope.autorisationsMinieresFilterees.forEach(function(autorisation) {
          if (autorisation.latitude && autorisation.longitude) {
            var marker = L.marker([autorisation.latitude, autorisation.longitude])
              .bindPopup(
                '<strong>' + (autorisation.numeroAutorisation || 'No. inconnu') + '</strong><br>' +
                'Type: ' + (autorisation.typeAutorisation || 'Non spécifié') + '<br>' +
                'Société: ' + (autorisation.societe || 'Non spécifiée') + '<br>' +
                'Substance: ' + (autorisation.substance || 'Non spécifiée') + '<br>' +
                '<a href="#!/autorisations-minieres/' + autorisation.id + '">Voir les détails</a>'
              );
            
            markers.addLayer(marker);
          }
        });
        
        window.autorisationsMap.addLayer(markers);
        
        // Ajuster la vue pour montrer tous les marqueurs si nécessaire
        if (markers.getLayers().length > 0) {
          window.autorisationsMap.fitBounds(markers.getBounds(), { padding: [50, 50] });
        }
        
        // Forcer le redimensionnement de la carte pour corriger les problèmes d'affichage
        setTimeout(function() {
          window.autorisationsMap.invalidateSize();
        }, 500);
      } catch (error) {
        console.error("Erreur lors de l'initialisation de la carte", error);
        document.getElementById('map-fallback-message').style.display = 'block';
      }
    }
  }
})();
